import React, { useState, useEffect, useRef, useCallback } from 'react'
import BlackComma from '../assets/svgs/black-comma.svg'
import Slider from 'react-slick';
import smileVideo from '../pngs/smile.mp4'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import "swiper/css";
import "swiper/css/pagination";
import 'swiper/css/navigation';
import '../components-css/our-testimonial-page.scss'
import { Helmet } from 'react-helmet-async';
import axios from 'axios'
import { BASE_URL } from '../config';

const OurTestimonialPage = () => {
  const swiperRef = useRef(null);
  const [happyClients, sethappyClients] = useState(null)
  const [loading, setLoading] = useState(true);
  const [isExpanded, setIsExpanded] = useState({});
  const [showReadMore, setShowReadMore] = useState({});
  const reviewRefs = useRef([])
  const [leftInfinite, setLeftInfinite] = useState([]);
  const [rightInfinite, setRightInfinite] = useState([]);

  // Use callback ref to ensure ref is properly assigned
  const setReviewRef = useCallback((node, index) => {
    if (node) {
      reviewRefs.current[index] = node;
      const height = node.clientHeight;

      // Update state only if it hasn't been set yet to prevent re-renders
      setShowReadMore((prev) => {
        if (!prev[index] && height > 199) {
          return { ...prev, [index]: true };
        }
        return prev;
      });
    }
  }, []);

  useEffect(() => {
    const testimonialData = async () => {
      try {
        let response = await axios.get(`${BASE_URL}/testimonial`)
        sethappyClients(response.data.data)
      }
      catch (err) {
        console.log(err)
      }
      finally {
        setLoading(false)
      }
    }

    testimonialData()
  }, [])

  useEffect(() => {
    const newShowReadMore = {}
    happyClients?.forEach((_, index) => {
      const el = reviewRefs.current[index]
      if (el && el.scrollHeight > 200) {
        newShowReadMore[index] = true
      } else {
        newShowReadMore[index] = false
      }
    })
    setShowReadMore(newShowReadMore)
  }, [happyClients])

  const [teamPhotos, setTeamPhotos] = useState([
    {
      name: "Saurav",
      designation: 'Finance Manager',
      img: "/Career page images/Mask-group-1.png",
    },
    {
      name: "Karina Bakshi",
      designation: 'HR Executive',
      img: "/Career page images/Mask-group-2.png",
    },
    {
      name: "Sandhya Kumari",
      designation: 'Senior UX/UI Designer',
      img: "/Career page images/Mask-group-3.png",
    },
    {
      name: "Rishabh Madan",
      designation: 'Full Stack Developer (US)',
      img: "/Career page images/Mask-group-4.png",
    },
    {
      name: "Vinit Vijayran",
      designation: 'Full Stack Developer',
      img: "/Career page images/Mask-group-5.png",
    },
    {
      name: "Pooja Arya",
      designation: 'Lead Php Software Developer',
      img: "/Career page images/Mask-group-6.png",
    },
    {
      name: "Mohit Kumar",
      designation: 'Php Developer',
      img: "/Career page images/Mask-group-7.png",
    },
    {
      name: "Shikha Pal",
      designation: 'Php Developer',
      img: "/Career page images/Mask-group.png",
    },
  ])

  const settings2 = {
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // Tablet breakpoint
        settings: {
          slidesToShow: 3, // Show 3 slides on tablet
        },
      },
      {
        breakpoint: 767, // Mobile breakpoint
        settings: {
          slidesToShow: 1, // Show 2 slides on mobile
        },
      },
    ],
    nextArrow: null,
    prevArrow: null,
  };

  useEffect(() => {
    if (!teamPhotos.length) return;

    // Duplicate arrays for seamless loop
    setLeftInfinite([...leftImages, ...leftImages]);
    setRightInfinite([...rightImages, ...rightImages]);
  }, [teamPhotos]);

  const midIndex = Math.ceil(teamPhotos.length / 2);
  const leftImages = teamPhotos.slice(0, midIndex);
  const rightImages = teamPhotos.slice(midIndex);

  // ---- METHOD 1: window blur/focus — fires when user clicks into an iframe ----
  useEffect(() => {
    let iframeClicked = false;

    const onWindowBlur = () => {
      if (document.activeElement && document.activeElement.tagName === 'IFRAME') {
        iframeClicked = true;
        swiperRef.current?.autoplay?.stop();
      }
    };

    const onWindowFocus = () => {
      if (iframeClicked) {
        iframeClicked = false;
        setTimeout(() => {
          swiperRef.current?.autoplay?.start();
        }, 500);
      }
    };

    window.addEventListener('blur', onWindowBlur);
    window.addEventListener('focus', onWindowFocus);
    return () => {
      window.removeEventListener('blur', onWindowBlur);
      window.removeEventListener('focus', onWindowFocus);
    };
  }, []);

  // ---- METHOD 2: YouTube postMessage API (needs enablejsapi=1 on iframe src) ----
  useEffect(() => {
    const onMessage = (event) => {
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

        // YouTube Player API state: -1=unstarted, 0=ended, 1=playing, 2=paused, 3=buffering, 5=cued
        if (data?.event === 'onStateChange') {
          if (data?.info === 1 || data?.info === 3) {
            swiperRef.current?.autoplay?.stop();
          } else if (data?.info === 0 || data?.info === 2) {
            swiperRef.current?.autoplay?.start();
          }
        }

        // infoDelivery format fallback
        if (data?.event === 'infoDelivery' && data?.info?.playerState !== undefined) {
          const playerState = data.info.playerState;
          if (playerState === 1 || playerState === 3) {
            swiperRef.current?.autoplay?.stop();
          } else if (playerState === 0 || playerState === 2) {
            swiperRef.current?.autoplay?.start();
          }
        }
      } catch (e) {
        // Ignore non-JSON or unrelated messages
      }
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);
  // ---- END VIDEO PLAY DETECTION ----

  return (
    <>
      <div className='Our-testimonial-page-main-container'>
        <Helmet>
          <title>Omka Tech Client Testimonials |  Reviews & Feedback</title>
          <meta name="description" content="See what clients say about Omka Tech. Read reviews and testimonials for our web, app development, IT, and digital marketing services" />
          <link rel="canonical" href="https://omkatech.com/our-testimonials" />
        </Helmet>
        <div className="core-team-container">
          <div className="left-content-testimonial">
            <h1>TESTIMONIALS</h1>
            <p>Words of praise from others about our presence.</p>
          </div>
          <div className="two-column-scroll">
            <div className="col col-down">
              <div className="scroll-track">
                {leftInfinite.map((img, i) => (
                  <img key={i} src={img.img} alt={img.name} />
                ))}
              </div>
            </div>

            <div className="col col-up">
              <div className="scroll-track">
                {rightInfinite.map((img, i) => (
                  <img key={i} src={img.img} alt={img.name} />
                ))}
              </div>
            </div>

          </div>
        </div>
        <div className="happy-clients">
          <h2>Here are some <b> Happy Clients</b> <video className="smiley-rotate" autoPlay loop muted playsInline preload="auto">
            <source type="video/mp4" src={smileVideo} />
            <source type="video/webm" src={smileVideo} />
          </video></h2>

          <div className='happy-clients-cards-responsive'>
            <Slider {...settings2}>
              {happyClients?.map((client) => {
                return <div className="happy-client-card-responsive">
                  <img src={BlackComma} alt="black-comma" />
                  <p className='review'>{client.review}</p>
                  <div className="about-client">
                    <div className='image-div'>
                      <img src={`${client.file_path}${client.image}`} alt="client-img" />
                    </div>
                    <div className="client-content">
                      <h5>{client.client_name}</h5>
                      <p>{client.client_designation} of {client.client_company}</p>
                    </div>
                  </div>
                </div>
              })}
            </Slider>
          </div>


          <div className="happy-clients-cards">
            {happyClients?.map((client, index) => (
              <div className="happy-client-card" key={index}>
                <img src={BlackComma} alt="black-comma" />

                <div className="review-wrapper">
                  <p
                    ref={(node) => setReviewRef(node, index)}
                    className={`review-text ${isExpanded[index] ? "expanded" : ""}`}
                  >
                    {client.review}
                  </p>

                  {!isExpanded[index] && showReadMore[index] && (
                    <div className="fade-overlay">
                      <span
                        className="read-more-btn"
                        onClick={() =>
                          setIsExpanded((prev) => ({ ...prev, [index]: true }))
                        }
                      >
                        Read More
                      </span>
                    </div>
                  )}

                  {isExpanded[index] && showReadMore[index] && (
                    <div className="read-less-container">
                      <span
                        className="read-more-btn"
                        onClick={() =>
                          setIsExpanded((prev) => ({ ...prev, [index]: false }))
                        }
                      >
                        Read Less
                      </span>
                    </div>
                  )}
                </div>

                <div className="about-client">
                  <div className="image-div">
                    <img src={`${client.file_path}${client.image}`} alt="client-img" />
                  </div>
                  <div className="client-content">
                    <h5>{client.client_name}</h5>
                    <p>{client.client_designation} of {client.client_company}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>


        </div>

      </div>
      <div className="client-say-about-us">
        <h2>What Our Clients Say About Us</h2>

        <Swiper
          onSwiper={(swiper) => { swiperRef.current = swiper; }}
          modules={[Navigation, Pagination, Autoplay]} // Add Autoplay module
          spaceBetween={20}
          slidesPerView={1}
          navigation={true}
          loop={happyClients?.length > 3} // Only enable loop if enough slides
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          breakpoints={{
            640: { slidesPerView: 2, spaceBetween: 15 },
            1024: { slidesPerView: 3, spaceBetween: 20 }
          }}
          className='slide-images-swiper'
        >
          {happyClients?.map(
            (videoUrl, index) =>
              videoUrl?.youtube_video_link && (
                <SwiperSlide key={index}>
                  <iframe
                    className='slide'
                    src={
                      videoUrl.youtube_video_link.includes('?')
                        ? `${videoUrl.youtube_video_link}&enablejsapi=1`
                        : `${videoUrl.youtube_video_link}?enablejsapi=1`
                    }
                    title={`YouTube video ${index + 1}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </SwiperSlide>
              )
          )}
        </Swiper>
      </div>
    </>
  )
}

export default OurTestimonialPage